export const ResearchController = {
    index(): void {},
};
